import React from 'react';
import PropTypes from 'prop-types';
import { propOr, prop } from 'ramda';
import moment from 'moment';

import { FormsCollection } from '../../../../ui-kit';

const SprintForm = ({
  handleChange,
  handleBlur,
  values,
  errors,
  getValidFinishDate,
  onChangeStartDate,
  startDateId = 'date-picker-start__new-sprint-modal',
  finishDateId = 'date-picker-finish__new-sprint-modal',
}) => (
  <>
    <FormsCollection.Input
      placeholderJump="Sprint title"
      name="title"
      onChange={handleChange}
      onBlur={handleBlur}
      value={values.title}
      touched
      error={propOr('', 'message', errors.title)}
      className="new-sprint__title-input"
      id="new-sprint__title"
    />
    <div className="new-sprint__row--textArea">
      <FormsCollection.TextArea
        placeholderJump="Description"
        className="new-sprint__textarea"
        name="description"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.description}
        error={prop('message', errors.description)}
        touched
        autoHeight
        maxHeight={100}
      />
    </div>
    <div className="new-sprint__date-fields-wrapper new-sprint__date-wrapper--start flex-row">
      <div className="date-field-label">
        <label htmlFor={startDateId}>Start</label>
      </div>
      <div className="new-sprint__inputs-wrapper">
        <FormsCollection.DatePicker
          className="date-picker"
          name="startDate"
          onChange={onChangeStartDate}
          onBlur={handleBlur}
          value={values.startDate}
          touched
          error={prop('message', errors.startDate)}
          id={startDateId}
        />
        <FormsCollection.TimePicker
          className="time-picker"
          name="startTime"
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={!values.startDate}
          touched
          value={values.startTime}
        />
      </div>
    </div>
    <div className="new-sprint__date-fields-wrapper new-sprint__date-wrapper--finish flex-row">
      <div className="date-field-label">
        <label htmlFor={finishDateId}>Finish</label>
      </div>
      <div className="new-sprint__inputs-wrapper">
        <FormsCollection.DatePicker
          className="date-picker"
          name="finishDate"
          onChange={handleChange}
          onBlur={handleBlur}
          touched
          error={prop('message', errors.finishDate)}
          value={getValidFinishDate()}
          minDate={
            values.startDate
              ? moment(values.startDate).add(1, 'day').toDate()
              : null
          }
          id={finishDateId}
        />
        <FormsCollection.TimePicker
          className="time-picker"
          name="finishTime"
          disabled={!values.finishDate}
          onChange={handleChange}
          onBlur={handleBlur}
          touched
          value={values.finishTime}
        />
      </div>
    </div>
  </>
);

SprintForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  getValidFinishDate: PropTypes.func.isRequired,
  onChangeStartDate: PropTypes.func.isRequired,
  startDateId: PropTypes.string,
  finishDateId: PropTypes.string,
};

SprintForm.defaultProps = {
  startDateId: 'date-picker-start__new-sprint-modal',
  finishDateId: 'date-picker-finish__new-sprint-modal',
};

export default SprintForm;
